import { EqlFieldName } from '@modules/common/constants';
import {
  OTHERS_DATA_POINT_PIE_CHART,
  UNASSIGNED_SENTIMENT_DATA_POINT_PIE_CHART,
} from '@modules/quantify/constants';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { QuantifyVisualisationType } from 'generated/graphql';
import { round } from 'lodash';

export function useGetQuantifyChartData() {
  const chartDataPoints = useQuantifyStore(({ reportData }) => {
    return reportData.quantify.chartDataPoints;
  });

  const groupBy = useQuantifyStore(({ query }) => query.groupByField);

  const activeVisualisationType = useQuantifyStore(
    ({ query }) => query.visualisationType,
  );

  if (!chartDataPoints?.length) {
    return [];
  }

  const selectedRecords = chartDataPoints.map((dataPoint) => ({
    ...dataPoint,
    id: dataPoint.id,
    label: dataPoint.label,
    value: round(dataPoint.value, 1),
  }));

  if (
    activeVisualisationType === QuantifyVisualisationType.Pie &&
    selectedRecords.length > 0
  ) {
    const totalPercentOfOthers =
      100 - chartDataPoints.reduce((acc, record) => acc + record.value, 0);

    const roundedPercentOfOthers = totalPercentOfOthers
      ? round(totalPercentOfOthers, 1)
      : null;

    if (roundedPercentOfOthers && roundedPercentOfOthers > 0) {
      return selectedRecords.concat([
        {
          label:
            groupBy?.field === EqlFieldName.UserSentiment
              ? UNASSIGNED_SENTIMENT_DATA_POINT_PIE_CHART
              : OTHERS_DATA_POINT_PIE_CHART,
          value: roundedPercentOfOthers,
          id: OTHERS_DATA_POINT_PIE_CHART,
          timestamp: undefined,
          entitySentiment: undefined,
          anomalyValue: undefined,
          isAnomalous: false,
          isRelevant: false,
          isUpdateInProgress: false,
          category: undefined,
          isInvisible: false,
        },
      ]);
    }
  }

  return selectedRecords;
}
